export class UrlUtils {
    static goToPage(url: string, id?: string) {
        const param = url.split(":")[1];
        return url.replace(`:${param}`, id ?? "")
    }
}